// extracted by mini-css-extract-plugin
export default {"root":"IconHeart_root__4ETas","outline":"IconHeart_outline__0NjGJ","filled":"IconHeart_filled__a-GgR"};